import { render } from "./IWSignup.vue?vue&type=template&id=085cb138"
import script from "./IWSignup.vue?vue&type=script&lang=js"
export * from "./IWSignup.vue?vue&type=script&lang=js"
script.render = render

export default script